import React from "react";
import "./DragLayer.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as widgetConfigActions } from "../../../../actions/widgetConfigActions";
import { actionCreators as uiActionCreators } from "../../../../actions/uiActions";

import {
  gridCoordsFromPosition
} from "../../../../helpers/grid";
import {
  GRID_SIZE
} from "../../../../helpers/constants";

import DragLine from "./DragLine";

class DragLayer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { mousex: 0, mousey: 0 };
    this._lastPosition = {
      gridCoords: {gridx:-1, gridy:-1 },
      widgetid:undefined
    }
  }
  componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove.bind(this));
    document.addEventListener("mouseup", this.onMouseUp.bind(this));
    this._widgets_container_el = document.getElementById("_dashboard-maincontent");
    this._widgets_container_outer_el = document.getElementById("widgets_container-outer");
    this._dashboard_maincontent_el = document.getElementById("_dashboard-maincontent");

  }
  componentWillUnmount() {
    // Make sure to remove the DOM listener when the component is unmounted.
    document.removeEventListener("mousemove", this.onMouseMove.bind(this));
    document.removeEventListener("mouseup", this.onMouseUp.bind(this));
  }

  onMouseUp(evt) {
    let {
      drag,
      cancelDrag,
      isActiveDrag,
      //isSensorDrag,
      isWidgetDrag,
      isWidgetResizeDrag,
      deleteWidget,
      moveWigetOrigin,
      resizeWidget
    } = this.props;
    let { mousex = 0, mousey = 0 } = this.state;

    if (isWidgetDrag) {
      let { cursorOffsetX = 0, cursorOffsetY = 0 } = drag.source;

      mousex = mousex - this._dashboard_maincontent_el.offsetLeft + this._widgets_container_outer_el.scrollLeft + cursorOffsetX;
      mousey = mousey - this._dashboard_maincontent_el.offsetTop + this._widgets_container_outer_el.scrollTop + cursorOffsetY;

      let gridCoords = gridCoordsFromPosition(mousex, mousey, GRID_SIZE);
      if (gridCoords.gridx < 0 || gridCoords.gridy < 0) {
        let { drag } = this.props;
        cancelDrag();
        deleteWidget(drag.source.widgetid);
      } else {
        console.log("LAST MOVE", drag)
        moveWigetOrigin(gridCoords, drag.source.widgetid, true);
        cancelDrag();
      }
    }

    if (isActiveDrag) {
      //this.setState({ mousex: -5, mousey: -5 });
      // TODO: Timeout is hacky. The Problem is, that for sensor drop, the mousup handler
      // of WidgetHOC should fire first.
      setTimeout(() => {
        cancelDrag();
      }, 10);
    }

    // Only persist on mouseup resize
    if (isWidgetResizeDrag) {
      console.log("LAST RESIZE", drag)
      mousex = mousex - this._dashboard_maincontent_el.offsetLeft;
      mousey = mousey - this._dashboard_maincontent_el.offsetTop;
  
      let targetGridCoords = gridCoordsFromPosition(mousex, mousey, GRID_SIZE);      
      resizeWidget(targetGridCoords, drag.source.side, drag.source.widgetid, true);
    }
  }

  onMouseMove(evt) {
    let { drag } = this.props;
    if (true || drag.active) {
      //console.log("drag0 handleNvEnter", evt);
      let { clientX, clientY } = evt;
      this.setState({ mousex: clientX, mousey: clientY });
    }
  }

  renderDragLine() {
    let { mousex = 0, mousey = 0 } = this.state;

    let { drag } = this.props;

    let startx = drag.originx;
    let starty = drag.originy;

    let endx = mousex;
    let endy = mousey;
    let lineProps = {
      startx,
      starty,
      endx,
      endy
    };

    let show =
      drag.active && startx !== -5 && starty !== -5 && endx !== -5 && endy !== -5;

    let rv = null;
    if (show) {
      rv = show && <DragLine {...lineProps} />;
    }
    return rv;
  }

  moveWidget() {
    let { mousex = 0, mousey = 0 } = this.state;

    let { moveWigetOrigin, drag } = this.props;
    let { widgetid } = drag.source;
    let { cursorOffsetX = 0, cursorOffsetY = 0 } = drag.source;

    mousex = mousex - this._dashboard_maincontent_el.offsetLeft + this._widgets_container_outer_el.scrollLeft + cursorOffsetX;
    mousey = mousey - this._dashboard_maincontent_el.offsetTop + this._widgets_container_outer_el.scrollTop + cursorOffsetY;
    let gridCoords = gridCoordsFromPosition(mousex, mousey, GRID_SIZE);


    // Memoize last drag position
    if (widgetid === this._lastPosition.widgetid) {
      if ((gridCoords.gridx === this._lastPosition.gridCoords.gridx)&&(gridCoords.gridy === this._lastPosition.gridCoords.gridy)) {
        return;
      }
    }

    this._lastPosition = {
      gridCoords,
      widgetid
    }

    //console.log("MOVE", gridCoords, this._lastPosition)
    moveWigetOrigin(gridCoords, drag.source.widgetid, false);
  }

  resizeWidget() {
    
    let { mousex = 0, mousey = 0 } = this.state;
    let { resizeWidget, drag } = this.props;
    let { source } = drag;
    let { widgetid, side } = source;

    mousex = mousex - this._dashboard_maincontent_el.offsetLeft + this._widgets_container_outer_el.scrollLeft;
    mousey = mousey - this._dashboard_maincontent_el.offsetTop + this._widgets_container_outer_el.scrollTop;

    let targetGridCoords = gridCoordsFromPosition(mousex, mousey, GRID_SIZE);

    if (widgetid === this._lastPosition.widgetid) {
      if ((targetGridCoords.gridx === this._lastPosition.gridCoords.gridx)&&(targetGridCoords.gridy === this._lastPosition.gridCoords.gridy)) {
        return;
      }
    }

    this._lastPosition = {
      gridCoords:targetGridCoords,
      widgetid
    }
    resizeWidget(targetGridCoords, side, widgetid, false);
  }

  componentDidUpdate(prevProps, prevState){
    let {
      //drag,
      isActiveDrag,
      //isSensorDrag,
      isWidgetDrag,
      isWidgetResizeDrag
    } = this.props;


    if (isActiveDrag) {
       if (isWidgetDrag) {
        this.moveWidget.bind(this)();
      } else if (isWidgetResizeDrag) {
        this.resizeWidget.bind(this)();
      }
    }
  }

  render() {

    let {
      //drag,
      isActiveDrag,
      isSensorDrag,
      //isWidgetDrag,
      //isWidgetResizeDrag
    } = this.props;

    let element = null;

    if (isActiveDrag) {
      if (isSensorDrag) {
        element = this.renderDragLine.bind(this)();
      }
    }

    return (
      <div className="draglayer">
        <svg height="100%" width="100%">
          {element}
        </svg>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let drag = state.ui.drag;
  let isActiveDrag = drag.active && drag.source && drag.source.type;
  let isSensorDrag = isActiveDrag && drag.source.type === "sensor";
  let isWidgetDrag = isActiveDrag && drag.source.type === "widget";
  let isWidgetResizeDrag = isActiveDrag && drag.source.type === "widget_resize";
  return {
    drag,
    isActiveDrag,
    isSensorDrag,
    isWidgetDrag,
    isWidgetResizeDrag
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...uiActionCreators, ...widgetConfigActions },
    dispatch
  );
}

const ConnectedDragLayer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DragLayer);

export default ConnectedDragLayer;
